module.exports = __webpack_public_path__ + "static/media/flooring1.3efead6c.jpg";